import React from "react";
import classNames from "classnames/bind";
import styles from "./PrimaryCard.module.scss";
import PrimaryCardPills from "./PrimaryCardPills";
import PrimaryCardProps from "./types";

const cx = classNames.bind(styles);

// TODO: this component should not exist
/**
 * a card to display a title, description, author and optional pills
 */
const PrimaryCard = ({
  id,
  title,
  description,
  onClick,
  pills = [],
  isLoading = false,
  isSolo = false,
  meta,
  cardConfig = {
    hasGreyBar: true,
    hasDescriptionLabel: true,
    hasReducedHeight: false,
  },
}: PrimaryCardProps) => {
  return (
    <>
      {isLoading ? (
        <button
          className={cx("container", "loading", {
            "container-solo": isSolo,
            reducedHeightContainer: cardConfig.hasReducedHeight,
          })}
        >
          <div className={cx("skeletons")}>
            <div
              className={cx("skeleton")}
              style={{ width: 240 }}
            />
            <div>
              <div
                className={cx("skeleton")}
                style={{ width: 240 }}
              />
              <div
                className={cx("skeleton")}
                style={{ width: 240 }}
              />
              <div
                className={cx("skeleton")}
                style={{ width: 240 }}
              />
            </div>
            <div className={cx("skeleton")} />
          </div>
        </button>
      ) : (
        <button
          className={cx("container", {
            "container-solo": isSolo,
            reducedHeightContainer: cardConfig.hasReducedHeight,
          })}
          onClick={() => onClick(id)}
        >
          <div className={cx("titleContainer")}>
            <p className={cx("title")}>{title}</p>
          </div>

          <div className={cx("descriptionContainer")}>
            <p className={cx("description")}>{description}</p>
          </div>

          <p className={cx("meta")}>{meta}</p>
          {cardConfig?.hasGreyBar ? <PrimaryCardPills pills={pills} /> : null}
        </button>
      )}
    </>
  );
};

export default PrimaryCard;
